// extracted by mini-css-extract-plugin
export var boldText = "_6u-4";
export var checkboxContainer = "_6u-6";
export var closeIcon = "_6u-i";
export var container = "_6u-0";
export var drawer = "_6u-8";
export var drawerContent = "_6u-9";
export var extraSmallText = "_6u-5";
export var fulfillmentGroupTable = "_6u-e";
export var largeText = "_6u-3";
export var loadingSpinnerContainer = "_6u-j";
export var mediumText = "_6u-2";
export var narrow = "_6u-f";
export var notificationLink = "_6u-l";
export var packageCheckIconContainer = "_6u-7";
export var slideoutHeaderActions = "_6u-g";
export var slideoutHeaderActionsShifted = "_6u-h";
export var slideoutHeaderContainer = "_6u-a";
export var slideoutModal = "_6u-c";
export var stickyHeaderWrapper = "_6u-b";
export var table = "_6u-k";
export var tableContainer = "_6u-d";
export var tertiaryText = "_6u-1";